module.exports = __webpack_public_path__ + "static/media/logo.987de4a8.svg";